import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Logo } from 'components/Logo';
import { Button, Input } from 'components/ui';
import CirculerShadow from 'components/ui/CirculerShadow';
import { BACK_TO_WEBSITE_LINK } from 'config/constants';

export const UpdatePassword: React.FC = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { updatePassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    const { error } = await updatePassword(password);

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      // Success - redirect to login
      navigate('/login', {
        state: { message: 'Password updated successfully! Please log in with your new password.' }
      });
    }
  };

  return (
    <div className="min-h-screen relative flex flex-col items-center justify-center bg-gray-100">
      <div className="w-full justify-between fixed top-0 max-w-7xl mx-auto z-10 flex pt-6 px-6">
        <Logo />
        <a
          href={BACK_TO_WEBSITE_LINK}
          className="text-sm font-medium text-gray-600 hover:text-primary transition-colors"
        >
          ← Back to Website
        </a>
      </div>

      <div className='my-4 py-6 text-center'>
        <h1 className='text-4xl font-medium'>Update your password</h1>
        <p className='text-xs'>Enter your new password below</p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-md w-96">
        <form className='space-y-3' onSubmit={handleSubmit}>
          <Input
            type='password'
            label='New Password'
            name='password'
            placeholder='New Password'
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
            disabled={loading}
          />

          <Input
            type='password'
            label='Confirm New Password'
            name='confirmPassword'
            placeholder='Confirm New Password'
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
            required
            disabled={loading}
          />

          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm">
              {error}
            </div>
          )}

          <Button
            type='submit'
            className='mt-6'
            variant='primary'
            size='sm'
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Password'}
          </Button>
        </form>
      </div>

      <div className='md:absolute hidden -top-30 right-0 '>
        <CirculerShadow className='' />
      </div>
    </div>
  );
};
